// // CommonDataGrid.jsx
// import React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import {
//     Box,
//     Typography,
//     IconButton,
//     Button,
//     useTheme,
//     LinearProgress
// } from '@mui/material';
// import {
//     ChevronLeft as ChevronLeftIcon,
//     ChevronRight as ChevronRightIcon
// } from '@mui/icons-material';

// // --- 3) Custom pagination footer -----------------------------------------
// const CustomPagination = ({ paginationModel, setPaginationModel, total }) => {
//     const theme = useTheme();
//     const { page, pageSize } = paginationModel;
//     const totalPages = Math.ceil(total / pageSize);
//     const startEntry = total > 0 ? page * pageSize + 1 : 0;
//     const endEntry = Math.min((page + 1) * pageSize, total);

//     const handlePageChange = (newPage) => {
//         setPaginationModel(prev => ({ ...prev, page: newPage }));
//     };

//     // Helper to generate visible pages with ellipsis
//     const getVisiblePages = () => {
//         const pages = [];
//         if (totalPages <= 10) {
//             for (let i = 0; i < totalPages; i++) pages.push(i);
//         } else {
//             pages.push(0);
//             const left = Math.max(page - 1, 1);
//             const right = Math.min(page + 1, totalPages - 2);

//             if (left > 1) pages.push('start-ellipsis');
//             for (let i = left; i <= right; i++) pages.push(i);
//             if (right < totalPages - 2) pages.push('end-ellipsis');
//             pages.push(totalPages - 1);
//         }
//         return pages;
//     };

//     const visiblePages = getVisiblePages();

//     return (
//         <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//             sx={{ padding: '10px', borderTop: '1px solid #E5E7EB' }}
//         >
//             <Typography variant="body2">
//                 Showing {total > 0 ? startEntry : 0} to {total > 0 ? endEntry : 0} of {total} items
//             </Typography>

//             {/* Pagination Controls */}
//             <Box display="flex" alignItems="center" gap={1}>
//                 <IconButton
//                     size="small"
//                     disabled={paginationModel.page === 0}
//                     onClick={() => handlePageChange(paginationModel.page - 1)}
//                 >
//                     <ChevronLeftIcon />
//                 </IconButton>

//                 {visiblePages.map((page, index) => {
//                     if (page === "start-ellipsis" || page === "end-ellipsis") {
//                         return (
//                             <Typography key={index} sx={{ width: '35px', textAlign: 'center' }}>
//                                 …
//                             </Typography>
//                         );
//                     }
//                     return (
//                         <Button
//                             key={page}
//                             size="small"
//                             variant={paginationModel.page === page ? "contained" : "outlined"}
//                             onClick={() => handlePageChange(page)}
//                             sx={{
//                                 background: paginationModel.page === page ? theme.palette.primary.main : 'transparent',
//                                 color: paginationModel.page === page ? theme.palette.secondary.main : '#000000',
//                                 border: "1px solid #E5E7EB",
//                                 width: '35px',
//                                 height: '35px',
//                                 minWidth: '35px',
//                                 boxShadow: 'none'
//                             }}
//                         >
//                             {page + 1}
//                         </Button>
//                     );
//                 })}

//                 <IconButton
//                     size="small"
//                     disabled={paginationModel.page >= totalPages - 1}
//                     onClick={() => handlePageChange(paginationModel.page + 1)}
//                 >
//                     <ChevronRightIcon />
//                 </IconButton>
//             </Box>
//         </Box>
//     );
// };

// // --- 4) The main CommonDataGrid component -------------------------------

// /**
//  * Props:
//  *  - columns, rows, rowCount, loading
//  *  - paginationModel: { page: number, pageSize: number }
//  *  - setPaginationModel: fn
//  *  - rowHeight (optional)
//  */
// export default function CommonDataGrid({
//     columns,
//     rows,
//     rowCount,
//     loading,
//     paginationModel,
//     setPaginationModel,
// }) {
//     return (
//         <DataGrid
//             autoHeight
//             disableColumnMenu={true}
//             disableDensitySelector={true}
//             disableVirtualization={true}
//             disableColumnResize
//             disableSelectionOnClick={false}
//             disableColumnSelector={true}
//             disableColumnFilter={true}
//             rows={rows}
//             columns={columns}
//             rowCount={rowCount}
//             loading={loading}
//             disableColumnSorting={true}
//             paginationMode="server"
//             slots={{
//                 footer: () => (
//                     <CustomPagination
//                         paginationModel={paginationModel}
//                         setPaginationModel={setPaginationModel}
//                         total={rowCount}
//                     />
//                 ),
//             }}
//         />
//     );
// }




// CommonDataGrid.jsx
import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box,
  Typography,
  IconButton,
  Button,
  useTheme,
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { TableSkeleton } from 'utils/constant';

export const CustomPagination = ({ paginationModel, setPaginationModel, total }) => {
  const theme = useTheme();
  const { page, pageSize } = paginationModel;
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;
  const startEntry = total > 0 ? page * pageSize + 1 : 0;
  const endEntry = Math.min((page + 1) * pageSize, total);

  const handlePageChange = newPage =>
    setPaginationModel(prev => ({ ...prev, page: newPage }));

  const getVisiblePages = () => {
    const pages = [];
    if (totalPages <= 10) {
      for (let i = 0; i < totalPages; i++) pages.push(i);
    } else {
      pages.push(0);
      const left = Math.max(page - 1, 1);
      const right = Math.min(page + 1, totalPages - 2);
      if (left > 1) pages.push('start-ellipsis');
      for (let i = left; i <= right; i++) pages.push(i);
      if (right < totalPages - 2) pages.push('end-ellipsis');
      pages.push(totalPages - 1);
    }
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <Box className='d-flex align-items-center justify-content-between'
      sx={{
        padding: '10px',
        borderTop: '1px solid #E5E7EB',
        px: 2
      }}
    >
      <Typography variant="body2">
        Showing {total > 0 ? startEntry : 0} to {total > 0 ? endEntry : 0} of{' '}
        {total} items
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          size="small"
          disabled={page === 0}
          onClick={() => handlePageChange(page - 1)}
        >
          <ChevronLeftIcon />
        </IconButton>

        {visiblePages.map((p, idx) =>
          typeof p === 'string' ? (
            <Typography key={idx} sx={{ width: 35, textAlign: 'center' }}>
              …
            </Typography>
          ) : (
            <Button
              key={p}
              size="small"
              variant={page === p ? 'contained' : 'outlined'}
              onClick={() => handlePageChange(p)}
              sx={{
                width: 35,
                height: 35,
                minWidth: 35,
                boxShadow: 'none',
                bgcolor:
                  page === p
                    ? theme.palette.primary.main
                    : 'transparent',
                color:
                  page === p
                    ? theme.palette.primary.contrastText
                    : 'text.primary',
                borderColor: 'divider',
              }}
            >
              {p + 1}
            </Button>
          )
        )}

        <IconButton
          size="small"
          disabled={page >= totalPages - 1}
          onClick={() => handlePageChange(page + 1)}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default function CommonDataGrid({
  columns,
  rows,
  rowCount,
  loading,
  paginationModel,
  setPaginationModel,
  /** you can also pass a height prop if you like */
  gridHeight = "calc(100vh - 210px)",
  minHeight,
  maxHeight,
  border = true,
  isPagination = true,
  rowHeight,
  renderCustomNoRowsOverlay,
  renderCustomFooter
}) {
  const theme = useTheme();
  // turn the function into a slot component, only if provided
  const NoRowsOverlaySlot = renderCustomNoRowsOverlay
    ? () => <>{renderCustomNoRowsOverlay()}</>
    : undefined;

  const FooterSlot = renderCustomFooter
    ? () => <>{renderCustomFooter()}</>
    : undefined;

  return (
    <Box sx={{ minHeight: minHeight ? minHeight : 'auto', width: '100%' }}>
      {loading ?
        <TableSkeleton />
        :
        <Box sx={{ height: 'auto' }}>
          <DataGrid
            autoHeight
            rows={rows}
            columns={columns}
            rowCount={rowCount}
            // loading={loading}
            paginationMode="server"
            pageSize={paginationModel?.pageSize}
            page={paginationModel?.page}
            rowHeight={rowHeight ? rowHeight : 'normal'}
            getRowId={(row) => (row.id !== undefined && row.id !== null) ? row.id : row?.menu_item_id}   // 👈 Fix here
            onPageChange={newPage =>
              setPaginationModel(prev => ({ ...prev, page: newPage }))
            }
            onPageSizeChange={newPageSize =>
              setPaginationModel(prev => ({
                ...prev,
                pageSize: newPageSize,
              }))
            }
            disableColumnMenu
            disableDensitySelector
            disableColumnResize
            disableColumnSelector
            disableColumnFilter
            disableColumnSorting
            // slots={{
            //   footer: () => (
            //     <CustomPagination
            //       paginationModel={paginationModel}
            //       setPaginationModel={setPaginationModel}
            //       total={rowCount}
            //     />
            //   ),
            // }}
            slots={{
              footer: FooterSlot
                ? FooterSlot
                : () => {
                  return isPagination ? (
                    <CustomPagination
                      paginationModel={paginationModel}
                      setPaginationModel={setPaginationModel}
                      total={rowCount}
                    />
                  ) : null;
                },
              noRowsOverlay: NoRowsOverlaySlot
            }}
            sx={{
              border: '1px solid #E5E7EB !important',
              // borderRadius: "0px !important",
              '& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]': {
                backgroundColor: '#F5F5F5 !important',
              },
              '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle': {
                color: '#6E6E6E',
                height: '50px !important',
                background: '#F5F5F5 !important',
                display: 'flex !important',
                alignItems: 'center !important',
              },
              '& .MuiDataGrid-columnHeader:first-of-type, & .MuiDataGrid-columnHeaderTitle': {
                paddingLeft: "10px"
              },
              // '& .MuiDataGrid-row': {
              //   paddingLeft: "10px"
              // },
              '& .MuiDataGrid-columnHeaders': {
                position: 'static',
              },
              '& .MuiDataGrid-footerContainer': {
                position: 'static',
                bgcolor: theme.palette.background.paper,
              },
              // ensure the data area scrolls
              '& .MuiDataGrid-virtualScroller': {
                overflowY: 'auto',
              },
              '& .MuiDataGrid-row.Mui-selected': {
                backgroundColor: 'transparent'
              },
              '& .MuiDataGrid-row.Mui-selected:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
              },
              // also remove the box-shadow when a cell becomes "selected"
              '& .MuiDataGrid-cell.Mui-selected': {
                outline: 'none',
                boxShadow: 'none',
              },
              minHeight: minHeight ? minHeight : 'auto !important',
              maxHeight: 'none !important',
              overflow: 'auto'
            }}
          />
        </Box>
      }
    </Box>
  );
}
